var styles = {"small":"Small-module_small__8F--E","secondary":"Small-module_secondary__45T7r","error":"Small-module_error__rb1ww"};

export { styles as default };
//# sourceMappingURL=Small.module.scss.js.map
